import {
    VIDEO_WINDOW_OPEN,
    VIEW_USER_REQUEST,
    VIDEO_WINDOW_STATE_BLOCKED
} from '../constants/streaming';

const blockingMiddleware = (store) => (next) => (action) => {
    // handling block on viewing start

    if (action.type == VIDEO_WINDOW_OPEN) {
      	let ufrag = action.ufrag;
        if (!ufrag && !action.streamer) {
          return next(action);
        }
        if (!ufrag) {
            ufrag = action.streamer.ufrag;
        }
        let {currentUser, users} = store.getState(),
            user = users.get({ufrag: ufrag});

        if (user && currentUser.isBeingBlocked(user)) {
            return next({...action, windowStateOverride: VIDEO_WINDOW_STATE_BLOCKED})
        }
    }

    if (action.type == VIEW_USER_REQUEST) {
        let ufrag = action.ufrag;
        if (!ufrag && !action.streamer) {
          return next(action);
        }
        if (!ufrag) {
            ufrag = action.streamer.ufrag;
        }
      
        let {currentUser, users} = store.getState(),
            user = users.get({ufrag: ufrag});

        let preventViewUserRequest = false;
        if (user && currentUser.isBeingBlocked(user)) preventViewUserRequest = true;

        if (preventViewUserRequest) {
            // prevent another middleware to work here
            return false;
        }
    }

    // todo: handle PM session start here as well

    next(action);
};

export default blockingMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/blocking.js